import React from "react";
import { motion } from "framer-motion";
import { fadeVariants } from "../lib/motion";

const cardEnter = fadeVariants({ x: 30, duration: 0.9, delay: 0.2 });

const floatLoop = {
    animate: { y: [0, -8, 0] },
    transition: { duration: 5, repeat: Infinity },
};

const stats = [
    { l: "Spread", v: "0.6 pips" },
    { l: "High", v: "1.0851" },
    { l: "Low", v: "1.0791" },
];

function ChartSvg() {
    return (
        <svg
            viewBox="0 0 400 140"
            className="w-full h-32"
            preserveAspectRatio="none"
        >
            <defs>
                <linearGradient id="lg" x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stopColor="#A6E3DC" stopOpacity="0.45" />
                    <stop offset="100%" stopColor="#A6E3DC" stopOpacity="0" />
                </linearGradient>
            </defs>
            <path
                d="M0,90 L30,80 L60,95 L90,70 L120,82 L150,55 L180,68 L210,40 L240,50 L270,30 L300,42 L330,22 L360,35 L400,18 L400,140 L0,140 Z"
                fill="url(#lg)"
            />
            <path
                d="M0,90 L30,80 L60,95 L90,70 L120,82 L150,55 L180,68 L210,40 L240,50 L270,30 L300,42 L330,22 L360,35 L400,18"
                fill="none"
                stroke="#A6E3DC"
                strokeWidth="2"
            />
        </svg>
    );
}

function FloatingCryptoCard() {
    return (
        <motion.div
            {...floatLoop}
            className="absolute -bottom-6 -left-6 hidden sm:block xpo-glass p-4 w-56"
        >
            <p className="font-mono text-[10px] text-slate-400 tracking-wider">
                BTC / USD
            </p>
            <p className="font-mono text-xl font-bold text-white mt-1">
                71,240.50
            </p>
            <p className="text-[#00FFC2] text-xs font-mono mt-0.5">▲ 2.41%</p>
        </motion.div>
    );
}

export default function HeroChartCard() {
    return (
        <motion.div
            variants={cardEnter}
            initial="hidden"
            animate="visible"
            className="lg:col-span-5 relative"
        >
            <div className="xpo-glass p-6 lg:p-7 relative">
                <div className="flex items-center justify-between mb-5">
                    <div>
                        <p className="font-mono text-xs text-slate-400 tracking-wider">
                            EUR / USD · M15
                        </p>
                        <p className="font-mono text-2xl font-bold text-white mt-1">
                            1.0832
                            <span className="text-[#00FFC2] text-sm ml-2">
                                +0.18%
                            </span>
                        </p>
                    </div>
                    <span className="text-[10px] font-bold tracking-widest text-[#A6E3DC] border border-[#A6E3DC]/40 rounded px-2 py-1">
                        LIVE
                    </span>
                </div>

                <ChartSvg />

                <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-white/5">
                    {stats.map((s) => (
                        <div key={s.l}>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest">
                                {s.l}
                            </p>
                            <p className="font-mono text-sm text-white font-semibold mt-0.5">
                                {s.v}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <FloatingCryptoCard />
        </motion.div>
    );
}
